import { useEffect, useState } from 'react'
import api from '../services/api'

const ACAO_CORES = {
  tramitar: { bg:'#E6F1FB', cor:'#185FA5', icone:'➡️' },
  aprovar:  { bg:'#EAF3DE', cor:'#3B6D11', icone:'✅' },
  concluir: { bg:'#EEEDFE', cor:'#534AB7', icone:'🏁' },
}

export default function FluxoProgresso({ processo, compact }) {
  const [fluxo, setFluxo] = useState([])
  const [load, setLoad] = useState(false)

  useEffect(() => {
    if (!processo?.tipo_id) return
    setLoad(true)
    api.get(`/fluxos/${processo.tipo_id}`)
      .then(r => setFluxo(r.data))
      .catch(() => {})
      .finally(() => setLoad(false))
  }, [processo?.tipo_id])

  if (load || !fluxo.length) return null

  // Usar fluxo_passo_atual do processo — mais preciso que buscar pelo setor
  const passoAtualIdx = processo.fluxo_passo_atual ?? 
    fluxo.findIndex(p => p.setor_id === processo.setor_atual_id)
  
  const statusFinal = ['concluido', 'arquivado'].includes(processo.status)
  const totalPassos = fluxo.length

  if (compact) {
    return (
      <div style={{ display:'inline-flex', alignItems:'center', gap:6, background: statusFinal ? '#EAF3DE' : '#f0f7ff', border:`1px solid ${statusFinal ? '#bbf7d0' : '#B5D4F4'}`, borderRadius:8, padding:'4px 10px', fontSize:12 }}>
        <span style={{ color:'#9ca3af' }}>Fase:</span>
        {statusFinal
          ? <span style={{ color:'#3B6D11', fontWeight:500 }}>✅ {totalPassos}/{totalPassos} — Concluído</span>
          : <span style={{ color:'#185FA5', fontWeight:500 }}>
              {passoAtualIdx + 1}/{totalPassos} — {fluxo[passoAtualIdx]?.nome_passo || fluxo[0]?.nome_passo}
            </span>
        }
      </div>
    )
  }

  return (
    <div style={{ background:'white', borderRadius:12, border:'1px solid #e5e7eb', padding:20, marginBottom:16 }}>
      <div style={{ fontSize:13, fontWeight:500, marginBottom:16, display:'flex', alignItems:'center', justifyContent:'space-between' }}>
        <span>🔀 Fluxo do processo</span>
        <span style={{ fontSize:12, color:'#9ca3af' }}>
          {statusFinal ? 'Concluído' : `Passo ${passoAtualIdx + 1} de ${totalPassos}`}
        </span>
      </div>

      <div style={{ position:'relative' }}>
        {/* Linha de fundo */}
        <div style={{ position:'absolute', top:16, left:16, right:16, height:2, background:'#e5e7eb', zIndex:0 }} />
        {/* Linha de progresso */}
        <div style={{
          position:'absolute', top:16, left:16, height:2, zIndex:1,
          background:'#185FA5',
          width: statusFinal ? '100%' : passoAtualIdx <= 0 ? '0%' : `${(passoAtualIdx / (totalPassos - 1)) * 100}%`,
          transition:'width 0.4s ease'
        }} />

        <div style={{ display:'flex', justifyContent:'space-between', position:'relative', zIndex:2 }}>
          {fluxo.map((passo, i) => {
            const concluido = statusFinal || i < passoAtualIdx
            const atual = i === passoAtualIdx && !statusFinal
            const cores = ACAO_CORES[passo.acao] || ACAO_CORES.tramitar

            return (
              <div key={passo.id} style={{ display:'flex', flexDirection:'column', alignItems:'center', flex:1 }}>
                <div style={{
                  width:32, height:32, borderRadius:'50%', display:'flex', alignItems:'center', justifyContent:'center', fontSize:14,
                  background: concluido ? '#185FA5' : atual ? cores.bg : 'white',
                  border: `2px solid ${concluido ? '#185FA5' : atual ? cores.cor : '#d1d5db'}`,
                  color: concluido ? 'white' : atual ? cores.cor : '#9ca3af',
                  fontWeight: 600,
                  boxShadow: atual ? `0 0 0 4px ${cores.bg}` : 'none',
                  transition:'all 0.2s'
                }}>
                  {concluido ? '✓' : atual ? cores.icone : i + 1}
                </div>

                <div style={{ marginTop:8, textAlign:'center', maxWidth:90 }}>
                  <div style={{ fontSize:11, fontWeight: atual ? 600 : 400, color: concluido ? '#185FA5' : atual ? cores.cor : '#9ca3af', lineHeight:1.3 }}>
                    {passo.nome_passo}
                  </div>
                  {passo.setor_nome && (
                    <div style={{ fontSize:10, color:'#9ca3af', marginTop:2 }}>{passo.setor_nome}</div>
                  )}
                  {atual && passo.descricao && (
                    <div style={{ marginTop:6, background:cores.bg, border:`1px solid ${cores.cor}22`, borderRadius:6, padding:'4px 6px', fontSize:10, color:cores.cor, lineHeight:1.4 }}>
                      📋 {passo.descricao}
                    </div>
                  )}
                </div>
              </div>
            )
          })}

          {/* Passo final */}
          <div style={{ display:'flex', flexDirection:'column', alignItems:'center', flex:1 }}>
            <div style={{
              width:32, height:32, borderRadius:'50%', display:'flex', alignItems:'center', justifyContent:'center', fontSize:16,
              background: statusFinal ? '#3B6D11' : 'white',
              border: `2px solid ${statusFinal ? '#3B6D11' : '#d1d5db'}`,
              color: statusFinal ? 'white' : '#9ca3af',
            }}>
              {statusFinal ? '✓' : '🏁'}
            </div>
            <div style={{ marginTop:8, textAlign:'center' }}>
              <div style={{ fontSize:11, fontWeight: statusFinal ? 600 : 400, color: statusFinal ? '#3B6D11' : '#9ca3af' }}>
                Concluído
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
